import { queryOptions } from '@tanstack/react-query';

import { usersApi } from '@/features/users/api';

export const usersKeys = {
    all: ['users'] as const,
    list: (q: string) => ['users', 'list', q] as const,
    one: (id: number) => ['users', 'one', id] as const,
    changes: (id: number) => ['users', 'changes', id] as const,
    relationshipManagers: ['users', 'relationship-managers'] as const,
    designations: ['users', 'designations'] as const,
    roles: ['users', 'roles'] as const,
};

export const usersListQuery = (q: string) =>
    queryOptions({ queryKey: usersKeys.list(q), queryFn: () => usersApi.list(q || undefined) });

export const relationshipManagersQuery = queryOptions({
    queryKey: usersKeys.relationshipManagers,
    queryFn: usersApi.relationshipManagers,
});

export const designationsQuery = queryOptions({
    queryKey: usersKeys.designations,
    queryFn: usersApi.designations,
    staleTime: 10 * 60_000,
});

/** What each role allows. Changes only with a deploy, so it is read once a session. */
export const staffRolesQuery = queryOptions({
    queryKey: usersKeys.roles,
    queryFn: usersApi.roles,
    staleTime: Infinity,
});
